export default __webpack_public_path__ + "static/media/12-32-27 2.bda9aebb.jpg";